module.exports = __webpack_public_path__ + "static/media/split.0f472bed.svg";